<template>
  <section class="group" >
    <b-collapse
      :open="true"
      class="card"
      style="box-shadow: none"
    >
      <div :class="{ 'card-header__border' : props.open }" slot="trigger" slot-scope="props" class="card-header">
        <!-- :style="{'box-shadow':!props.open?'none':'box-shadow: 0 2px 5px rgba(10, 10, 10, 0.08), 0 0 0 1px rgba(10, 10, 10, 0.05)'}" -->
        <p class="card-header-title">
          <span @click.stop="toggle_group_classes()" class="toggle-icon is-flex ml" style="border-right:0;padding-left: 6px;">
            <img class="fa-eye-btn" v-if="active" src="@/assets/icons/eye.svg"  />
            <img class="fa-eye-btn" v-else src="@/assets/icons/eye-inactive.svg"  />
            <!-- <i class="fa fa-eye-btn" :class="{'fa-eye':active,'fa-eye-slash':!active}"></i> -->
          </span>
          <span class="group_name is-medium-16-500-19">{{ truncateStr(feature_type_group.name || "NA") }}</span>
          <span
            class="group-actions"
            v-if="edit_mode && $store.getters.has_modify_feautes_type_permissions"
          >
            <i
              class="fa-edit-btn fa fa-edit has-text-warning"
              @click="$emit('edit',feature_type_group)"
            ></i>
            <i class="fa-delete-btn fa fa-trash has-text-danger" @click="deleteFeatureTypeGroup()"></i>
          </span>
        </p>
        <a class="card-header-icon">
          <svg viewBox="0 0 100 100" class="image is-24x24">
            <use v-if="!props.open" xlink:href="@/assets/icons/sprite.svg#collapse" />
            <use v-else xlink:href="@/assets/icons/sprite.svg#expand-feature-types" />
          </svg>
        </a>
      </div>
      <div class="card-content">
        <div class="create-form" v-if="$store.getters.has_modify_feautes_type_permissions">
          <!-- <a
            v-if="!is_create && !is_edit"
            @click="is_create=!is_create;"
            class="button btn is-small"
          >
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>Add Feature Type</span>
          </a>-->
          <div class="field" style="position:relative" v-if="is_create || is_edit">
            <div class="color-input">
              <span
                @click="is_active_colors=!is_active_colors"
                class="icon is-small is-left select-color"
              >
                <i class="fas fa-circle fa-lg" :style="{'color':form.properties.color}"></i>
              </span>
              <input
                v-model="form.name"
                @keyup.enter="save()"
                class="input is-small"
                ref="name"
                autofocus
                @focus="is_active_colors=false"
                :placeholder="localization('app-name','Name')"
              />
            </div>
            <div v-if="is_active_colors" class="color-list has-text-center">
              <i
                v-for="(color,i) in colors"
                :key="i"
                @click="form.properties=color;is_active_colors=false"
                @keyup.enter="save()"
                :class="{'selected':color.color===form.properties.color}"
                :style="{'color':color.color}"
                class="fas fa-circle fa-2x"
              ></i>
            </div>
            <div class="buttons are-small">
              <span class="button is-danger" @click="save()">Add Feature Type</span>
              <span
                class="button cancel-btn"
                @click="is_create=false;is_edit=false;form.name=''"
              >Cancel</span>
            </div>
          </div>
        </div>
        <div v-if="feature_type_group" style="width: 100%">
          <feature-type
            v-for="(feature_type,i) in sort(feature_type_group.featureTypes)"
            :key="i"
            :feature_type="feature_type"
            :is_group_active="active"
            @onDeleteFeature="$emit('onDeleteFeature')"
            @edit="onEdit($event)"
            :edit_mode.sync="edit_mode"
          ></feature-type>
        </div>
      </div>
    </b-collapse>
  </section>
</template>
<script>
import FeatureType from "./feature-type.component";
import { mapGetters, mapState, mapMutations } from "vuex";
import FeatureTypeService from "@/services/feature-type.service";
import FeatureTypeGroupService from "@/services/feature-type-group.service";
import color_list from "./color-list.json";
import _ from "lodash";
export default {
  props: ["feature_type_group", "edit_mode"],
  data: function() {
    return {
      featureTypeService: new FeatureTypeService(),
      featureTypeGroupService: new FeatureTypeGroupService(),
      is_create: false,
      is_edit: false,
      active: true,
      is_active_colors: true,
      colors: color_list,
      form: {
        name: "",
        properties: { color: null }
      }
    };
  },
  components: {
    FeatureType
  },

  computed: {
    ...mapState(["claims", "container"])
  },
  methods: {
    truncateStr(name) {
      return _.truncate(name || "NA", {
        length: 18,
        separator: " "
      });
    },
    onEdit(ft) {
      this.is_edit = true;
      this.form = Object.assign({}, ft);
    },
    sort(data) {
      if (data && data.length) return _.sortBy(data, ["id"]);
      return [];
    },
    save() {
      if (!this.form.properties.color) {
        this.$toast.open("Please select the color.");
        return;
      }

      if (this.is_edit) {
        this.is_edit = false;
        this.featureTypeService
          .patch({
            uid: this.form.uid,
            body: {
              name: this.form.name,
              properties: this.form.properties
            }
          })
          .then(res => {
            this.reset_form();
            this.$emit("on_add_feature_type");
          });
      } else if (this.is_create) {
        this.is_create = false;
        this.featureTypeService
          .post({
            body: {
              ...this.form,
              featureTypeGroup: this.feature_type_group.uid
            }
          })
          .then(res => {
            this.reset_form();
            this.$emit("on_add_feature_type");
          });
      }
    },
    toggle_group_classes() {
      this.active = !this.active;
    },
    deleteFeatureTypeGroup() {
      this.$dialog.confirm({
        type: "is-danger",
        message: `Are you sure?`,
        confirmText: "Yes",
        cancelText: "No",
        onConfirm: async () => {
          this.featureTypeGroupService
            .unassign_from_container({
              body: { featureTypeGroup: this.feature_type_group.uid },
              id: this.container.uid
            })
            .then(res => {
              if (res.status == 200) {
                this.$emit("onDeleteFeature");
                this.$toast.open("Deleted successfully!");
              } else {
                this.$toast.open("Could not delete!!");
              }
            })
            .catch(err => {
              this.$toast.open("Could not delete! Try again");
              this.handleErrors(err);
            });
        }
      });
    },
    reset_form() {
      this.form = {
        name: "",
        properties: { color: null }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.group {
  margin : 0 0.5rem;
  border-bottom: 1px solid #eee;
  .card-header {
    box-shadow: none;
    &__border {
      border-bottom: 1px solid #eee;
    }
  }
  .card-header-title {
    font-family: Barlow-medium;
    font-size: 16px;
    color: #171e48;
    margin: 0;
    padding: 0;
    text-align: left;
    .toggle-icon {
      display: inline-block;
      height: 100%;
      margin-right: 1rem;
      margin-left: 0.5rem;
    }
    .fa{
      height: 100%;
      margin-right: 1rem;
      margin-left: 0.5rem;
      display: flex;
      align-items: center;
    }
    .group_name {
      font-size: 15px;
      font-weight: 500;
      text-transform: capitalize;
      position: relative;
      justify-content: left;
      width: 130px;
      z-index: 1;
      @media (max-width: 900px) {
        width: 100px;
      }
    }
    .group-actions {
      display: flex;
      z-index: 10;
      right: 2.5rem;
      top: 10px;
      position: absolute;
      i {
        margin: 3px;
      }
    }
  }
  .active {
    color: #000;
    font-weight: 500;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.1rem 0.5rem 1rem 0.5rem;
  }
  .create-form {
    margin-bottom: 0.5rem;
    padding: 0 9px;
    .btn {
      border: 0;
    }

    .color-list {
      z-index: 100;
      background: white;
      position: absolute;
      width: 100%;
      height: 210px;
      left: 0;
      top: 2rem;
      bottom: 1rem;
      border: 1px solid #ccc;
      .fas {
        cursor: pointer;
        margin: 0.5rem;
      }
    }
    .buttons {
      margin-top: 0.5rem;
      .cancel-btn {
        border: none;
      }
    }
    .color-input {
      display: flex;
      align-items: center;
      border: 1px solid grey;
      .icon {
        margin: 0 8px;
      }
      .input {
        box-shadow: none;
        border: none;
      }
    }
  }
}
</style>
